/* ll-stock.js — het voorraadgetal volgt de gekozen maat.
 *
 * De bron zet een kaart van variant-id naar getal in `window.mcStockMap` en
 * werkt het cijfer bij zodra de variant wisselt. Zonder dat staat er bij elke
 * maat hetzelfde getal — precies wat de eigenaar zag.
 *
 * Horizon stuurt geen `variant:change`, dus we lezen de gekozen variant uit de
 * verborgen `input[name="id"]` van het koopformulier en kijken daarnaast naar
 * de radioknoppen van de variantkiezer. Bij een wissel vervangt Horizon dit
 * blok soms; de waarnemer hieronder zet het getal dan opnieuw.
 */
(() => {
  const kaart = () => window.llStockKaart || {};

  /* Het id dat we NU willen tonen. Nodig omdat Horizon het blok vlak na de klik
     opnieuw neerzet met de oude serverwaarde (gemeten: goed op 24ms, terug op
     25ms, pas definitief op 439ms). Zolang `input[name="id"]` nog de oude
     variant draagt, is dit de waarheid. */
  let gewenstId = null;

  function huidigeVariant() {
    const invoer = document.querySelector('form[action*="/cart/add"] input[name="id"], product-form-component input[name="id"]');
    if (invoer && invoer.value) return String(invoer.value);
    const aan = document.querySelector('variant-picker input:checked[data-variant-id]');
    return aan ? String(aan.getAttribute('data-variant-id')) : null;
  }

  function zet(idOverride) {
    const el = document.querySelector('[data-ll-stock-aantal]');
    if (!el) return;
    const id = idOverride || gewenstId || huidigeVariant();
    if (!id) return;
    const n = kaart()[id];
    if (n == null) return;
    if (el.textContent !== String(n)) el.textContent = String(n);
  }

  function nu(idOverride) {
    zet(idOverride);
    /* Horizon hertekent het blok over het netwerk; nog een keer erachteraan.
       Het id MOET meegegeven blijven: `input[name="id"]` draagt tot na die
       hertekening nog de OUDE variant. Zonder dit zette de tweede aanroep het
       getal meteen weer terug op de oude waarde — dat was de vertraging die de
       eigenaar zag (gemeten: goed op 15ms, weer fout, pas goed op 391ms). */
    setTimeout(() => zet(idOverride), 60);
    setTimeout(() => zet(idOverride), 400);
  }

  nu();
  document.addEventListener('change', (e) => {
    const doel = e.target;
    if (!doel || !doel.closest || !doel.closest('variant-picker')) return;

    /* METEEN bijwerken met het id dat op de aangeklikte knop zelf staat.
       `input[name="id"]` van het formulier wordt pas NA Horizons eigen
       verwerking bijgezet — daarop wachten gaf precies de vertraging die de
       eigenaar zag. Het `data-variant-id` staat er al vóór de klik.
       Daarna nog een keer via de gewone weg, voor het geval de combinatie van
       kleur en maat een ander variant-id oplevert. */
    const direct = doel.getAttribute && doel.getAttribute('data-variant-id');
    if (direct) gewenstId = direct;
    nu(direct || null);
    /* Zodra het formulier bijgetrokken is, laten we `gewenstId` weer los. */
    setTimeout(() => { if (huidigeVariant() === gewenstId) gewenstId = null; }, 1200);
  }, true);
  document.addEventListener('shopify:section:load', nu);

  /* Waarnemer met dezelfde twee sloten als bij de koopknop: alleen ingrijpen als
     het getal niet meer klopt, en loskoppelen tijdens het schrijven. */
  const blok = document.querySelector('.product-information');
  if (blok) {
    let w = null;
    const kijk = () => {
      const el = document.querySelector('[data-ll-stock-aantal]');
      const id = gewenstId || huidigeVariant();
      if (!el || !id) return;
      const n = kaart()[id];
      if (n == null || el.textContent === String(n)) return;
      w.disconnect(); zet(); w.observe(blok, { childList: true, subtree: true });
    };
    w = new MutationObserver(kijk);
    w.observe(blok, { childList: true, subtree: true });
  }
})();
